import { RouteConfig } from '@/modules/core/app/helpers/RouteConfig';
import { getters } from '/@/modules/core/app/helpers/store';

export class EstateSummaryRouteConfig extends RouteConfig {
  canAccessRoute(): boolean {
    return !!getters.auth.getUser()?.isInFinancialAdvisorProfessionGroup;
  }
}
